import {i18n, i18n as lang} from '@appbase/util'

const langSuffix: { [key: string]: string[] } = {    
    'ko': [ 'kr', 'kor', ''],
    'en': [ 'en', 'eng', '_en', '_eng' ],
    'cn': [ 'chi', 'cn', 'ch', '_ch', '_cn' ],
    'jp': [ 'jpn' ]
}

//Object 내 프로퍼티를 NameKey로 참조하기위한 유틸
export const getProperty = function<T>(obj: T, propkey: string | number) {
    var key = propkey as (keyof T)
    return obj[key];
}

export const setProperty = function<T>(obj: T, propkey: string | number, value: any) {
    var key = propkey as (keyof T);
    obj[key] = value;
}

export const deepCopy = function<T>(obj: T) {    
    if(obj == null || typeof(obj) !== "object" || Array.isArray(obj)) {
        return obj;
    }

    var copy = {} as T;

    for(var key in obj) {
        setProperty(copy, key, deepCopy(obj[key]));
    }

    return copy;
}

export const getNullSafeString = function(obj: any) {
    if (obj == null)
        return "";
    else
        return String(obj);
}

export const getLangProperty = function(obj: any, propkey: string): string {  
    if(obj == undefined || obj == null)
        return '';

    var properties = Object.keys(obj);
    var langProperties = langSuffix[i18n.locale].map(s => `${propkey}${s}`.toLowerCase());
    var displayText: string | undefined = undefined;    

    for(let i = 0; i < langProperties.length; i++) {
        var langProperty = langProperties[i];
        var found = properties.find(p => p.toLowerCase() === langProperty);
        
        if(found) {
            displayText = obj[found];
        }
                
        if(displayText) break;
    }

    if(displayText == undefined || displayText == null || displayText.trim().length == 0) {
        return obj[propkey] || '';
    } else {
        return displayText;
    }
}